(function () {
  const links = document.querySelectorAll("[data-js-page-404-links] a");
  const wheel = document.querySelector("[data-js-page-404-spinner-wheel]");
  const toggles = document.querySelectorAll("[data-js-page-404-spin-toggle]");

  let isEnabled = links.length > 0 || false;

  for (const toggle of toggles) {
    toggle.addEventListener("click", () => {
      if (!isEnabled) return;
      const link = links[Math.floor(Math.random() * links.length)];
      wheel.dataset.spin = "true";
      isEnabled = false;

      link.addEventListener(
        "animationend",
        () => {
          window.location.href = link.href;
        },
        { once: true }
      );

      wheel.addEventListener(
        "animationend",
        () => {
          link.dataset.selected = "true";
          wheel.dataset.spin = "false";
        },
        { once: true }
      );
    });
  }
})();
